import { type JSONValue } from '../types';

type CacheValue = {
  stringified: string;
  value: JSONValue;
};

export const createStableJsonCache = () => {
  const cache = new Map<string, CacheValue>();

  return <V extends JSONValue>(key: string, newValue: V): V => {
    const oldValue = cache.get(key);

    if (oldValue !== undefined) {
      const newValueStr = JSON.stringify(newValue);
      const oldValueStr = oldValue.stringified;

      if (oldValueStr === newValueStr) {
        return oldValue.value as V;
      }
    }

    cache.set(key, { stringified: JSON.stringify(newValue), value: newValue });
    return newValue;
  };
};
